module.exports = __webpack_public_path__ + "img/13.c1bb7518.png";